import React, { useState, useEffect } from 'react';
import { Button, Input, InputNumber, Modal, Radio, Select } from 'antd';

function ExistingCountModal({
  visible,
  setVisible,
  productData,
  TotalCount,
  reqPayload,
  updateInventory
}) {
  const [countSplit, setCountSplit] = useState([null, null, null, null, null]);
  const [total, setTotal] = useState(0);

  const setArrayValue = (value, index) => {
    setCountSplit(prev => {
      const newState = prev.map((item, i) => {
        return index === i
          ? value
          : item
      });
      return newState;
    })
  }

  useEffect(() => {
    setCountSplit([null, null, null, null, null])
    if (productData?.CountSplit && visible) {
      let splitCount = !productData?.CountSplit?.toString()?.includes('+') ?
        [productData?.CountSplit] : productData?.CountSplit?.split('+').map(num => (num ? Number(num) : null)) || [];
      setCountSplit((prev) => {
        return prev.map((_, i) => (i < splitCount.length ? splitCount[i] : null));
      });
      let totalCount = splitCount.reduce((acc, value) => acc + value, 0);
      setTotal(totalCount);
    }
  }, [productData]);

  useEffect(() => {
    let totalCount = countSplit.reduce((acc, value) => acc + (Number(value) || 0), 0);
    let split = countSplit.toString().split(',').filter(Boolean).join('+');
    setTotal(totalCount);
    TotalCount(productData?.catId, productData, totalCount, split)
  }, [countSplit])
  return (
    <>
      <Modal
        title='Add to Existing Count'
        open={visible}
        onCancel={() => setVisible(false)}
        closable
        width={500}
        footer={[
          <Button
            key="cancel"
            className='Deactivate-Button'
            onClick={() => setVisible(false)}
          >
            Cancel
          </Button>,
          <Button
            key="add"
            onClick={() => {
              updateInventory(reqPayload);
              setVisible(false)
              // let totalCount = countSplit.reduce((acc, value) => acc + (Number(value) || 0), 0);
              // let split = countSplit.toString().split(',').filter(Boolean).join('+');
              // TotalCount(productData?.catId, productData, totalCount, split);
            }}
            className='printButton2'
          // disabled={inventoryName === ''}
          >
            Save
          </Button>
        ]}
      >
        <div>
          <div>
            <label>Product :</label>
            <Input value={`${productData?.Product}, ${productData?.SubProduct}`} readOnly />
          </div>
          <div style={{ marginTop: '10px' }}>
            <label>Counts :</label>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <InputNumber min={0} max={100000} value={countSplit[0] ?? ''} onChange={(value) => { setArrayValue(value, 0) }} type='number' maxLength={7} /> +
              <InputNumber min={0} max={100000} value={countSplit[1] || ''} onChange={(value) => { setArrayValue(value, 1) }} type='number' maxLength={7} /> +
              <InputNumber min={0} max={100000} value={countSplit[2] || ''} onChange={(value) => { setArrayValue(value, 2) }} type='number' maxLength={7} /> +
              <InputNumber min={0} max={100000} value={countSplit[3] || ''} onChange={(value) => { setArrayValue(value, 3) }} type='number' maxLength={7} /> +
              <InputNumber min={0} max={100000} value={countSplit[4] || ''} onChange={(value) => { setArrayValue(value, 4) }} type='number' maxLength={7} /> =
              <span>{total}</span>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ExistingCountModal
